<template>
  <tutorial-layout
    title="Emit"
    :referenceLinks="referenceLinks"
    :youtubeLinks="youtubeLinks"
  >
    <p slot="overview">
      $emit in Vue is primarily used for sending custom events between child
      components upwards to parent components. Since props (i.e. data) can only
      flow in a unidirectional format; custom events can be used to have child
      components notify the parent component about something.
      <br/>
      You can use this.$emit('eventName', dataToSend, ...) to send the data to the parent component that would then listen on the component like this &lt;my-component @eventName="yourHandler" /&gt;
    </p>

    <p slot="benefits">
      Vue.js events are callbacks, they are not DOM events. You can verify this, since you add a custom name to the event listener and not a DOM event name (click, focus...), and there is no event object passed to the function, unless you specify an $event argument in the $emit call.
    </p>
    
    <CustomEvent @changeMsg="setMessage" :msg="welcomeMsg"/>
    <br/>
    
    <EmitTutorial></EmitTutorial>
    <br />

    <h2>Output</h2>
    <br/>
    <v-card>
      <!-- <v-text-field solo-inverted @input="welcomeMsg2 = $event" placeholder="Type here to change the text" /> 
      <EmitEvent v-on:update="setMessage2($event)"></EmitEvent> -->
      <ParentComp></ParentComp>
    </v-card>
  </tutorial-layout>
</template>

<script>
import moment from "moment";

import uiView from "@/_mixins/ui-view-mixin";
import tutorialLayout from "../../components/tutorial-layout";
import CustomEvent from "./CustomEvent.vue";
// import EmitEvent from "./EmitEvent.vue";
import EmitTutorial from "./EmitTutorial.vue";
import ParentComp from './ParentComp.vue';

export default {
  name: "VModel",
  mixins: [uiView],
  created() {},
  data() {
    return {
      text1: "Example Text",
      welcomeMsg: "0",
      welcomeMsg2: "Welcome",
    };
  },
  components: {
    tutorialLayout,
    CustomEvent,
    // EmitEvent,
    EmitTutorial,
    ParentComp
  },
  props: {},
  watch: {},
  computed: {
    referenceLinks() {
      return [
        {
          title: "Emit Events to Parent Components",
          href: "https://openclassrooms.com/en/courses/5664336-create-a-web-application-with-vue-js/6535686-emit-events-to-parent-components",
        },
        {
          title: "Emit function in Vue",
          href: "https://masteringjs.io/tutorials/vue/emit",
        },
        {
          title: "Two-way data binding",
          href:
            "https://jithilmt.medium.com/vue-js-2-two-way-data-binding-in-parent-and-child-components-1cd271c501ba#:~:text=js%20has%20made%20this%20a%20lot%20easier%20from%202.3.&text=Just%20add%20this%20.,modified%20with%20the%20new%20value.",
        },
      ];
    },
    youtubeLinks() {
      return [
        {
          title: "VueJs CLI $emit",
          href: "https://www.youtube.com/embed/lgpjiSJR9VY",
        },
        {
          title: "Using Emit with Vue",
          href: "https://www.youtube.com/embed/BskYnvm18BQ",
        },
        {
          title: "Custom Events ($emit)",
          href: "https://www.youtube.com/embed/5pvG6fzkdFM",
        },
      ];
    },
  },
  methods: {
    setMessage(msg) {
      this.welcomeMsg = msg;
    },
    setMessage2(msg) {
      this.welcomeMsg2 = msg;
    },
  },
};
</script>
<style lang="scss">
</style>
